import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=e37e0fb6&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37e0fb6')) {
      api.createRecord('e37e0fb6', component.options)
    } else {
      api.reload('e37e0fb6', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=e37e0fb6&", function () {
      api.rerender('e37e0fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22ZQq1lHC3m6l/JS/priceformat.vue"
export default component.exports